import React from "react";
import { FaTrash, FaBan, FaCheck, FaEdit } from "react-icons/fa";
import LoadingSpinner from "../shared/LoadingSpinner";

const CompanyTable = ({ companies, loading, onSuspend, onEdit, onDelete }) => {
  if (loading) {
    return (
      <LoadingSpinner
        text="Loading companies..."
        size="md"
        className="py-10"
      />
    );
  }

  if (!companies.length) {
    return (
      <div className="flex items-center justify-center py-6">
        <span className="text-gray-500">No companies found.</span>
      </div>
    );
  }

  return (
    <div className="w-full h-auto mt-6">
      <table className="border-collapse w-full">
        <thead>
          <tr>
            <th className="bg-customeBlack text-white border-white border">Company ID</th>
            <th className="bg-customeBlack text-white border-white border">Name</th>
            <th className="bg-customeBlack text-white border-white border">Status</th>
            <th className="bg-customeBlack text-white border-white border">Users(Used/Max)</th>
            <th className="bg-customeBlack text-white border-white border">Plan</th>
            <th className="bg-customeBlack text-white border-white border">Created At</th>
            <th className="bg-customeBlack text-white border-white border">Actions</th>
          </tr>
        </thead>
        <tbody>
          {companies.map((c) => (
            <tr key={c.id}>
              <td className="border p-2">{c.id}</td>
              <td className="border p-2">{c.name}</td>
              <td className="border p-2">
                {c.suspended ? (
                  <span className="bg-amber-500 text-amber-950 p-1.5 rounded-md">Suspended</span>
                ) : (
                  <span className="bg-lime-500 text-lime-950 p-1.5 rounded-md">Active</span>
                )}
              </td>
              <td className="border p-2">{c.userCount ?? 0} / {c.maxUsers ?? "—"}</td>
              <td className="border p-2">{c.plan}</td>
              <td className="border p-2">
                {c.createdAt
                  ? new Intl.DateTimeFormat('en-GB', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                  }).format(new Date(c.createdAt))
                  : "—"}
              </td>
              <td className="border p-2 flex gap-2">
                <button
                  onClick={() => onSuspend(c.id, c.suspended)}
                  className={`text-white px-2 py-2 rounded ${c.suspended ? "bg-green-600" : "bg-yellow-600"
                    }`}
                >
                  {c.suspended ? <FaCheck /> : <FaBan />}
                </button>
                <button
                  onClick={() => onEdit(c)}
                  className="text-white bg-blue-600 px-2 py-1 rounded"
                >
                  <FaEdit />
                </button>
                <button
                  onClick={() => onDelete(c.id)}
                  className="text-white bg-red-600 px-2 py-1 rounded"
                >
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CompanyTable;